import React from 'react';
import { withRouter } from 'next/router';
import BasePage from '@/components/BasePage';
import Vaccines from '@/pages/vaccines';
import Error from '@/components/shared/Error';
import BasicLink from '@/Handlers/BasicLink';
import Booking from '@/components/Booking';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container } from 'reactstrap';

// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const VaccineLayout = ({ t, data }) => {
	if (data) {
		const what_is = [];
		for (let i = 1; i <= data.what_is; i++) {
			what_is.push(<p key={i}>{t(`${data.vaccine}.what_is.text${i}`)}</p>);
		}

		const can_be_vaccinated = [];
		for (let i = 1; i <= data.can_be_vaccinated; i++) {
			can_be_vaccinated.push(<p key={i}>{t(`${data.vaccine}.can_be_vaccinated.text${i}`)}</p>);
		}

		const protection = [];
		for (let i = 1; i <= data.protection; i++) {
			protection.push(<p key={i}>{t(`${data.vaccine}.protection.text${i}`)}</p>);
		}

		const occurrence = [];
		for (let i = 1; i <= data.occurrence; i++) {
			occurrence.push(<p key={i}>{t(`${data.vaccine}.occurrence.text${i}`)}</p>);
		}

		const source = [];
		for (let i = 1; i <= data.source; i++) {
			source.push(<li key={i}>{t(`${data.vaccine}.source.text${i}`)}</li>);
		}
		return (
			//React.Fragment is used instead of <div> or <> to hide it from source
			<React.Fragment>
				<BaseLayout
					className="cover"
					title={t(`${data.vaccine}.title`)}
					description={what_is[0].props.children}
					keywords={`${t(`${data.vaccine}.title`)} ${t('SEO.keywords_common')} ${t('SEO.keywords_vaccines')}`}
					canonical={`/vaccines/${t(`${data.vaccine}.title`)}`}
				>
					{/* Base Page - Shared component with Container */}
					<BasePage id="vaccines-page" className="vaccines-page pt-5" role="article">
						<Container>
							<article>
								<h1 className="font-weight-bold vaccines-title text-center">
									{t(`${data.vaccine}.title`)}
								</h1>
								{what_is.length > 0 && (
									<React.Fragment>
										<h2 className="page_subtext vaccines-header text-uppercase">
											{t('vaccines.headers.symptoms')}
										</h2>
										{what_is}
										<hr className="vaccination-page_hr" />
									</React.Fragment>
								)}
								{can_be_vaccinated.length > 0 && (
									<React.Fragment>
										<h2 className="page_subtext vaccines-header text-uppercase">
											{t('vaccines.headers.vaccination')}
										</h2>
										{can_be_vaccinated}
										{data.kids && (
											<BasicLink route="/kids" title={`(${t('vaccines.kids_programm')})`} />
										)}
										<hr className="vaccination-page_hr" />
									</React.Fragment>
								)}

								{protection.length > 0 && (
									<React.Fragment>
										<h2 className="page_subtext vaccines-header text-uppercase">
											{t('vaccines.headers.protection')}
										</h2>
										{protection}
										<hr className="vaccination-page_hr" />
									</React.Fragment>
								)}

								{occurrence.length > 0 && (
									<React.Fragment>
										<h2 className="page_subtext vaccines-header text-uppercase">
											{t('vaccines.headers.occurrence')}
										</h2>
										{occurrence}
										<hr className="vaccination-page_hr" />
									</React.Fragment>
								)}

								{source.length > 0 && (
									<React.Fragment>
										<h2 className="page_subtext vaccines-header text-uppercase">
											{t('vaccines.headers.source')}
										</h2>
										<ul>{source}</ul>
										{data.kids && (
											<React.Fragment>
												<hr className="vaccination-page_hr" />
												<p>{t('vaccines.kids_vaccination')}</p>
											</React.Fragment>
										)}
									</React.Fragment>
								)}

								<Booking />
								<Vaccines />
							</article>
						</Container>
					</BasePage>
				</BaseLayout>
			</React.Fragment>
		);
	} else {
		return <Error error={'Please Chose a Vaccine you want get information about'} />;
	}
};

const Vaccine = ({ router, t }) => {
	if (router.query.data) {
		let data = [];
		if (typeof window !== 'undefined') {
			localStorage.setItem('data_vaccines', router.query.data);
		}
		data = JSON.parse(router.query.data);
		return <VaccineLayout t={t} data={data} />;
	} else if (typeof window !== 'undefined') {
		const data = JSON.parse(localStorage.getItem('data_vaccines'));
		return <VaccineLayout t={t} data={data} />;
	} else {
		return <Error error={'Please Chose a Vaccine you want get information about'} />;
	}
};
export default translate(withRouter(Vaccine));
